import { ErrorResponse } from "../models/apiResponse";

const isErrorResponse = (data: any): data is ErrorResponse => {
  return (
    typeof data === "object" &&
    data !== null &&
    typeof data.raw === "string" &&
    typeof data.providerErrorCode === "string" &&
    typeof data.mappedErrorCode === "string" &&
    typeof data.devMsg === "string" &&
    typeof data.severity === "string" &&
    Array.isArray(data.customerMsg) &&
    data.customerMsg.every(
      (msg: any) =>
        typeof msg.language === "string" && typeof msg.content === "string"
    )
  );
};

export default isErrorResponse;
